import {
  createRulesetResolverBindings,
  RulesetResolver,
} from "@indietabletop/appkit";
import { client } from "../client.ts";
import { Ruleset, type RulesetData } from "../engine/Ruleset.ts";
import * as rulesetData from "../engine/rulesetData.ts";

export const resolver = new RulesetResolver({
  initialRuleset: new Ruleset({
    ...rulesetData,
    version: "1.4.0",
  }),

  async getRemoteRuleset(version) {
    const result = await client.getRuleset("spacegits", version);
    return result.mapSuccess((data) => new Ruleset(data as RulesetData));
  },
});

Object.assign(window, { rulesets: resolver });

export const { useResolveRuleset, useLatestRuleset } =
  createRulesetResolverBindings(resolver);
